import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import FormLabel from '@mui/material/FormLabel';
import Slider from '@mui/material/Slider';
import { ariaDescribedByIds, labelValue, rangeSpec } from '@rjsf/utils';
/** The `RangeWidget` component uses the `BaseInputTemplate` changing the type to `range` and wrapping the result
 * in a div, with the value along side it.
 *
 * @param props - The `WidgetProps` for this component
 */
export default function RangeWidget(props) {
  const {
    value,
    readonly,
    disabled,
    onBlur,
    onFocus,
    options,
    schema,
    onChange,
    required,
    label,
    hideLabel,
    id
  } = props;
  const sliderProps = {
    value,
    label,
    id,
    name: id,
    ...rangeSpec(schema)
  };
  const _onChange = (_, value) => {
    onChange(value !== null && value !== void 0 ? value : options.emptyValue);
  };
  const _onBlur = _ref => {
    let {
      target
    } = _ref;
    return onBlur(id, target && target.value);
  };
  const _onFocus = _ref2 => {
    let {
      target
    } = _ref2;
    return onFocus(id, target && target.value);
  };
  return _jsxs(_Fragment, {
    children: [labelValue(_jsx(FormLabel, {
      required: required,
      htmlFor: id,
      children: label || undefined
    }), hideLabel), _jsx(Slider, {
      disabled: disabled || readonly,
      onChange: _onChange,
      onBlur: _onBlur,
      onFocus: _onFocus,
      valueLabelDisplay: 'auto',
      ...sliderProps,
      "aria-describedby": ariaDescribedByIds(id)
    })]
  });
}